import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import {
  getFirestore,
  collection,
  query as fbQuery,
  orderBy as fbOrderBy,
  limit as fbLimit,
  where as fbWhere,
  onSnapshot as fbOnSnapshot,
  doc as fbDoc,
  serverTimestamp as fsServerTimestamp,
} from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import {
  getMessaging,
  isSupported,
  onMessage as onMessageFn,
  getToken as getTokenFn,
} from "firebase/messaging";

// ─── Config ────────────────────────────────────────────────────────────────

const firebaseConfig = {
  apiKey: "AIzaSyASohioB7uOjDw1OBIVm8bpD7eZLNI1Th8",
  authDomain: "nextserveio.firebaseapp.com",
  projectId: "nextserveio",
  storageBucket: "nextserveio.firebasestorage.app",
  messagingSenderId: "368631692699",
  appId: "1:368631692699:web:3789e5e0327df8cee0f53e",
  measurementId: "G-GJ07QM0WNF",
};

// ─── App Initialization ────────────────────────────────────────────────────

const app = initializeApp(firebaseConfig);

const db = getFirestore(app, process.env.REACT_APP_FIREBASE_DATABASE_ID);

export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Helper functions
export const currUser = () => auth.currentUser;
export const serverTimestamp = fsServerTimestamp;

// Messaging — safe async init (not all browsers support it)
let messaging = null;

isSupported()
  .then((supported) => {
    if (supported) {
      messaging = getMessaging(app);
    }
  })
  .catch((e) => {
    console.error("Firebase messaging not supported:", e);
  });

export const getFirebaseMessaging = () => messaging;
export const onMessageListener = (callback) => {
  if (!messaging) return () => {};
  return onMessageFn(messaging, callback);
};
export const getFirebaseToken = (options) => {
  if (!messaging) return null;
  return getTokenFn(messaging, options);
};
export { messaging };

// ─── Firestore Collection Refs ─────────────────────────────────────────────

const wrapFirestoreRef = (ref) => ({
  _ref: ref,
  orderBy: (field, direction) =>
    wrapFirestoreQuery(fbQuery(ref, fbOrderBy(field, direction))),
  limit: (count) => wrapFirestoreQuery(fbQuery(ref, fbLimit(count))),
  where: (field, op, value) =>
    wrapFirestoreQuery(fbQuery(ref, fbWhere(field, op, value))),
  doc: (id) => wrapFirestoreDoc(fbDoc(ref, id)),
  onSnapshot: (onNext, onError) => fbOnSnapshot(ref, onNext, onError),
});

const wrapFirestoreQuery = (queryRef) => ({
  _ref: queryRef,
  orderBy: (field, direction) =>
    wrapFirestoreQuery(fbQuery(queryRef, fbOrderBy(field, direction))),
  limit: (count) => wrapFirestoreQuery(fbQuery(queryRef, fbLimit(count))),
  where: (field, op, value) =>
    wrapFirestoreQuery(fbQuery(queryRef, fbWhere(field, op, value))),
  onSnapshot: (onNext, onError) => fbOnSnapshot(queryRef, onNext, onError),
});

const wrapFirestoreDoc = (docRef) => ({
  _ref: docRef,
  onSnapshot: (onNext, onError) => fbOnSnapshot(docRef, onNext, onError),
});

const newOrders = wrapFirestoreRef(collection(db, "newOrders"));
const bulkUploads = wrapFirestoreRef(collection(db, "bulkUploads"));

export const refs = {
  newOrders,
  bulkUploads,
};

export { db };
